import webinarSRHR from '../webinar-images/SRHR_in_UHC_plans_and_processes_in_Eastern_Europe_and_Central_Asia.png';
import webinarAdolescent from '../webinar-images/Strengthening_Adolescent-Responsive_Health_Systems.png';
import webinarTransportation from '../webinar-images/outsourced_transportation_service.jpg';
import webinarSRHR2 from '../webinar-images/Securing_the_Future_of_SRHR.jpg';
import webinarDigitalHealth from '../webinar-images/The_role_of_digital_health_in_expanding_access_to_sexual_and_reproductive_health_services.png';

export interface IWebinar {
    country: string;
    image: string;
    imagealt: string;
    title: string;
    description: string;
    watchTime: string;
    link: string;
    youtubeId: string;
}

export const webinars: IWebinar[] = [
    {
        country: 'Location',
        image: webinarDigitalHealth,
        imagealt: "A discussion with global health experts on how evidence-based digital health interventions can expand access to sexual and reproductive health services. With real-world examples, panelists from WHO, Love Matters Kenya, and Intelehealth explored practical strategies to leverage digital health to strengthen the delivery and accessibility of SRH services within Universal Health Coverage frameworks.",
        title: 'A discussion with global health experts on how evidence-based digital health interventions can expand access to sexual and reproductive health services. With real-world examples, panelists from WHO, Love Matters Kenya, and Intelehealth explored practical strategies to leverage digital health to strengthen the delivery and accessibility of SRH services within Universal Health Coverage frameworks.',
        description: 'A discussion with global health experts on how evidence-based digital health interventions can expand access to sexual and reproductive health services. With real-world examples, panelists from WHO, Love Matters Kenya, and Intelehealth explored practical strategies to leverage digital health to strengthen the delivery and accessibility of SRH services within Universal Health Coverage frameworks.',
        watchTime: '1 hr watch',
        link: 'https://youtu.be/BEi8p9Rivsg',
        youtubeId: 'BEi8p9Rivsg',
    },
    {
        country: 'Location',
        image: webinarTransportation,
        imagealt: "Experts and implementers discuss an outsourced transportation service that improves access to healthcare facilities",
        title: 'Experts and implementers discuss an outsourced transportation service that improves access to healthcare facilities',
        description: 'Experts and implementers discuss an outsourced transportation service that improves access to healthcare facilities for pregnant women and sick children in rural Punjab, Pakistan.',
        watchTime: '1 hr watch',
        link: 'https://youtu.be/k7Up1sqJMrw',
        youtubeId: 'k7Up1sqJMrw',
    },
    {
        country: 'Location',
        image: webinarSRHR,
        imagealt: "SRHR in UHC plans and processes in Eastern Europe and Central Asia",
        title: 'SRHR in UHC plans and processes in Eastern Europe and Central Asia',
        description: 'Shared experiences on integrating SRHR into the UHC agenda with WHO tools, guidance, and UNFPA/WHO support.',
        watchTime: '55 min watch',
        link: 'https://youtu.be/EDkaOrSA1DY',
        youtubeId: 'EDkaOrSA1DY',
    },
    {
        country: 'Location',
        image: webinarAdolescent,
        imagealt: "Strengthening Adolescent-Responsive Health Systems",
        title: 'Strengthening Adolescent-Responsive Health Systems',
        description: 'Experiences from Chile, Ethiopia, and Moldova integrating adolescent-friendly services into health systems.',
        watchTime: '1 hr watch',
        link: 'https://youtu.be/52ZX9jb1SZk',
        youtubeId: '52ZX9jb1SZk',
    },
    {
        country: 'Location',
        image: webinarSRHR2,
        imagealt: "Securing the Future of SRHR: Preserving Progress and Driving Sustainable Financing",
        title: 'Securing the Future of SRHR: Preserving Progress and Driving Sustainable Financing',
        description: 'A UNGA 80th session side event explored the impact of declining global SRHR funding and discussed strategies for sustainable financing, drawing on evidence from DSW’s 2025 Donors Delivering for SRHR report.',
        watchTime: '1.5 hr watch',
        link: 'https://youtu.be/l-oDLhIzQgo',
        youtubeId: 'l-oDLhIzQgo',
    }
]